import Machine from '../../../../components/form-items/machine/machine'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard, renderShipment } from '../../helpers/helpers'

export const additionalMachinesColumn: ShipmentColumn = {
    key: 'additional_machines',
    dataIndex: ['additional_machines'],
    relationPath: ['additional_machines'],
    title: 'Отд. станок',
    width: 80,
    editable: true,
    FormItem: (
        <Machine
            name={['additional_machines', 'set']}
            filters={{ machine_type: { name: { $contains: 'finishing' } } }}
            unique
            noStyle
            autoFocus
            mode={'multiple'}
        />
    ),
    render: renderShipment(
        shipment => shipment?.additional_machines?.map(x => x.name.split(' ')[0]).join(', ') || ''
    ),
    onCell: onCellStandard,
}
